/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type SubscriptionStatesEnum = 'SUBMITTED' | 'ACTIVE' | 'CANCELLED' | 'TERMINATED' | 'ERROR' | 'EXPIRED' | 'PENDING_PROVISIONING' | 'PENDING_ACTIVE' | 'PENDING_CANCEL' | 'SUSPENDED' | 'FUTURE';

export const SubscriptionStatesEnum = {

    SUBMITTED: 'SUBMITTED' as SubscriptionStatesEnum,

    ACTIVE: 'ACTIVE' as SubscriptionStatesEnum,

    CANCELLED: 'CANCELLED' as SubscriptionStatesEnum,

    TERMINATED: 'TERMINATED' as SubscriptionStatesEnum,

    ERROR: 'ERROR' as SubscriptionStatesEnum,

    EXPIRED: 'EXPIRED' as SubscriptionStatesEnum,

    PENDING_PROVISIONING: 'PENDING_PROVISIONING' as SubscriptionStatesEnum,

    PENDING_ACTIVE: 'PENDING_ACTIVE' as SubscriptionStatesEnum,

    PENDING_CANCEL: 'PENDING_CANCEL' as SubscriptionStatesEnum,

    SUSPENDED: 'SUSPENDED' as SubscriptionStatesEnum,

    FUTURE: 'FUTURE' as SubscriptionStatesEnum
};

